<template>
  <!--货主 -->
  <el-form-item label="货主">
    <el-select
      v-model="owner_name"
      :disabled="modify"
      filterable
      remote
      placeholder="请选择货主"
      @focus="remoteMethod_name"
      @change="unitName"
      clearable
    >
      <el-option
        v-for="(item, index) in ownerList"
        :key="index"
        :label="item.member_name"
        :value="item.user_id"
      ></el-option>
    </el-select>
    <!-- <i class="iconfont icon-icon12 unit"></i> -->
  </el-form-item>
</template>

<script>
import { isSuccess } from "@/assets/js/utils";
export default {
  data() {
    return {
      ownerList: [],
      owner_pid: this.ownerPid, //合同pid
      owner_name: this.ownerName, //合同名称
      modify: this.ownerModify,
      owner_user_ids: this.userIds,
    };
  },
  //   props: ['infoPid', 'infoCode', 'infoName', 'ifModify'],
  props: {
    ownerPid: {
      required: false,
    },
    ownerName: {
      required: false,
    },
    ownerModify: {
      required: false,
    },
    userIds: {
      required: false,
    },
  },
  created() {},
  watch: {
    ownerPid: function (newVal, oldVal) {
      this.owner_pid = newVal;
    },
    ownerName: function (newVal, oldVal) {
      this.owner_name = newVal;
    },
    ownerModify: function (newVal, oldVal) {
      this.modify = newVal;
    },
    userIds: function (newVal, oldVal) {
      this.owner_user_ids = newVal;
    },
  },
  methods: {
    remoteMethod_name() {
      let json = [];
      if (this.owner_user_ids) {
        this.owner_user_ids.forEach((item) => {
          json.push(item.user_id);
        });
      }
      api("entrust.entrust.list", { user_ids: json }).then((res) => {
        let data;
        if ((data = isSuccess(res))) {
          this.ownerList = data;
        }
      });
    },
    unitName(val) {
      this.owner_name = this.ownerList.find((item) => {
        return item.user_id === val;
      }).member_name;
      this.$emit("getOwner", val, this.owner_name);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/unitcode/entrust-code.vue